import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ContactService } from '../../../../core/services/Contact/contact.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from '../../../../core/services/Language/lang.service';

@Component({
  selector: 'app-contact-content-section',
  imports: [ReactiveFormsModule],
  templateUrl: './contact-content-section.component.html',
  styleUrl: './contact-content-section.component.css',
})
export class ContactContentSectionComponent implements OnInit {
  private readonly fb=inject(FormBuilder)
  private readonly contactService=inject(ContactService)
  public readonly languageService=inject(LanguageService);
contactForm!:FormGroup;
   subscription: Subscription = new Subscription();

   private toastr = inject(ToastrService);

   messageTypes = [
  { value: 'General Inquiry', ar: 'استفسار عام', en: 'General Inquiry' },
  { value: 'Contract Opportunity', ar: 'فرصة تعاقد', en: 'Contract Opportunity' },
  { value: 'Technical Support', ar: 'دعم فني', en: 'Technical Support' },
  { value: 'Broker Program', ar: 'برنامج الوسطاء', en: 'Broker Program' },
  { value: 'Complaint', ar: 'شكوى', en: 'Complaint' },
  { value: 'Other', ar: 'أخرى', en: 'Other' },
];

ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
const FULL_NAME = /^\s*[A-Za-z\u0600-\u06FF]+(?:\s+[A-Za-z\u0600-\u06FF]+){2,}\s*$/;

  const PHONE = /^\+[1-9]\d{7,14}$/;

  this.contactForm = this.fb.group({
    full_name: [
      null,
      [
        Validators.required,
        Validators.pattern(FULL_NAME),
        Validators.maxLength(60),
      ],
    ],
    email: [null, [Validators.required, Validators.email]],
    phone: [null, [Validators.required, Validators.pattern(PHONE)]],
    message: [null, [Validators.required, Validators.minLength(10)]],
    message_type: ['General Inquiry', [Validators.required]]
  });
}

  onSubmit(): void {
  if (this.contactForm.invalid) {
    this.contactForm.markAllAsTouched();
    this.toastr.error('برجاء مراجعة البيانات وإكمال الحقول المطلوبة', 'خطأ');

    return;
  }

  this.subscription?.unsubscribe();

  this.subscription = this.contactService
    .createContact(this.contactForm.value)
    .subscribe({
      next: (response) => {
        console.log(response)
        if (response?.success){
        const msg = response?.message ?? 'تم إرسال الرسالة بنجاح';
          this.toastr.success(msg, 'نجاح');
          this.contactForm.reset();
        }
      },
      error:(err)=>{
        this.toastr.error('حدث خطأ أثناء إرسال الرسالة، حاول مرة أخرى', 'خطأ');
      }
    });
}

getMessageTypeLabel(type: { ar: string; en: string }): string {
  const lang = this.languageService.getLang();
  return lang === 'ar' ? type.ar : type.en;
}

    }
